import { LAYER_NAMES } from './layerNames';

export const SEPARATED_POINTS_LAYER_ORDER = [
	//BOTTOM LAYER
	LAYER_NAMES.SEPARATED_POINTS_LAYER,
	LAYER_NAMES.SEPARATED_HOVERED_POINTS,
	//LAYER_NAMES.SEPARATED_HOVERED_POINTS_TEXT,
	//TOP LAYER
];
